import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonToolbar, Button } from 'reactstrap';
import renderField from '../../../shared/components/form/RenderField';
import Select from '../../../shared/components/form/Select';
import CheckBoxGroup from '../../../shared/components/form/NestedList/CheckBoxGroup';

import {
  profileUsers,
  profileFeatures,
  allTypesOfCommunicationForAudit,
  tabletItens,
  findItemTabletByProfile,
  findByProfileCommunicationTypes,
} from '../../../shared/queries/AccessProfile';
import GraphQL from '../../../GraphQL';
import validate from './Validate';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';

const AccessProfileForm = (props) => {
  const {
    t,
    handleSubmit,
    backHandler,
    dto,
    initialize,
    showLoading,
    hideLoading,
    change,
  } = props;

  const [availableMembers, setavailableMembers] = useState([]);
  const [availableCommunicationTypes, setAvailableCommunicationTypes] =
    useState([]);
  const [availableTabletItems, setAvailableTabletItems] = useState([]);
  const [features, setFeatures] = useState([]);

  const useStyles = makeStyles((theme) => ({
    Grid: {
      padding: theme.spacing(1, 2),
      border: '1px solid #e0e1e2',
      overflow: 'auto',
    },
  }));

  const classes = useStyles();

  function loadLinkedTabletItems() {
    showLoading();
    const query = findItemTabletByProfile(dto.id);
    GraphQL(query, {})
      .then((res) => {
        change('linkedItemsTablet', res.findItemTabletByProfile);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  function loadLinkedCommunicationTypes() {
    showLoading();
    const query = findByProfileCommunicationTypes(dto.id);
    GraphQL(query, {})
      .then((res) => {
        res.findByProfileCommunicationTypes =
          res.findByProfileCommunicationTypes.map((item) => ({
            ...item,
            value: item.id,
            label: t(`communication-type.${item.type}`),
          }));
        change(
          'linkedTypecommunicationTypessComu',
          res.findByProfileCommunicationTypes
        );
        hideLoading();
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  const loadUserForProfileMaintenance = () => {
    const query = profileUsers(dto.id);
    GraphQL(query, {})
      .then((res) => {
        if (res.loadProfileAccessData.availableUsers) {
          setavailableMembers(res.loadProfileAccessData.availableUsers);
          if (dto.id) {
            change('linkedUsers', res.loadProfileAccessData.linkedUsers);
          }
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAvailableCommunicationTypes = () => {
    const query = allTypesOfCommunicationForAudit();
    GraphQL(query, {}).then((res) => {
      if (res.findCommunicationTypesForAudit) {
        res.findCommunicationTypesForAudit =
          res.findCommunicationTypesForAudit.map((item) => ({
            ...item,
            value: item.id,
            label: t(`communication-type.${item.type}`),
          }));

        setAvailableCommunicationTypes(res.findCommunicationTypesForAudit);
      }
    });
  };

  const loadAvailableTabletItem = () => {
    const query = tabletItens();
    GraphQL(query, {}).then((res) => {
      if (res.findAllItemTablet) {
        res.findAllItemTablet = res.findAllItemTablet.map((item) => ({
          ...item,
          value: item.itemId,
          label: item.itemName,
        }));

        setAvailableTabletItems(res.findAllItemTablet);
      }
    });
  };

  const loadFeatures = () => {
    showLoading();
    const query = profileFeatures(dto.id);
    GraphQL(query, {})
      .then((res) => {
        if (res.profileFeatures) {
          res.profileFeatures = res.profileFeatures.map((item) => ({
            id: item.id,
            profileId: item.profileId,
            featureId: item.featureId,
            featureName: item.featureName,
            featureType: item.featureType,
            fatherFeatureId: item.fatherFeatureId,
            hasAcess: item.hasAcess,
            childrens: item.childrens,
          }));
          hideLoading();
          setFeatures(res.profileFeatures);
          change('profileFeatures', res.profileFeatures);
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const itemClickHandler = (clickedItem, isChecked) => {
    let updatedChildrenList;
    let updatedItem;

    if (clickedItem.childrens && clickedItem.childrens.length > 0) {
      updatedChildrenList = clickedItem.childrens.map((child) => ({
        ...child,
        hasAcess: isChecked,
      }));
      updatedItem = {
        ...clickedItem,
        hasAcess: isChecked,
        childrens: updatedChildrenList,
      };
    } else {
      const father = features.find(
        (feature) => feature.featureId === clickedItem.fatherFeatureId
      );

      if (father) {
        updatedChildrenList = father.childrens.map((child) => ({
          ...child,
          hasAcess:
            child.featureId === clickedItem.featureId
              ? isChecked
              : child.hasAcess,
        }));
        const hasAcessFather = updatedChildrenList.some(
          ({ hasAcess }) => hasAcess
        );
        updatedItem = {
          ...father,
          hasAcess: hasAcessFather,
          childrens: updatedChildrenList,
        };
      } else {
        updatedItem = {
          ...clickedItem,
          hasAcess: isChecked,
          childrens: [],
        };
      }
    }

    const updatedFeatureList = [...features];
    const updatedItemIndex = updatedFeatureList.findIndex(
      (feature) => feature.featureId === updatedItem.featureId
    );
    updatedFeatureList[updatedItemIndex] = updatedItem;
    setFeatures(updatedFeatureList);
    change('profileFeatures', updatedFeatureList);
  };

  useEffect(() => {
    initialize(dto);
    loadUserForProfileMaintenance();
    loadAvailableCommunicationTypes();
    loadAvailableTabletItem();
    loadFeatures();

    if (dto.id !== 0) {
      loadLinkedCommunicationTypes();
      loadLinkedTabletItems();
    } else {
      dto.linkedUsers = null;
      dto.linkedTypesComu = null;
      dto.linkedItemsTablet = null;
    }
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.name')}</span>
          <div className="form__form-group-field">
            <Field
              name="name"
              type="text"
              component={renderField}
              placeholder={t('general.name')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_access_profiles.members')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="linkedUsers"
              type="text"
              component={Select}
              isMulti
              closeMenuOnSelect={false}
              options={availableMembers}
              placeholder={t('mnt_access_profiles.members')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_access_profiles.communication')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="linkedTypecommunicationTypessComu"
              type="text"
              component={Select}
              isMulti
              closeMenuOnSelect={false}
              options={availableCommunicationTypes}
              placeholder={t('mnt_access_profiles.communication')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_access_profiles.tablet')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="linkedItemsTablet"
              type="text"
              component={Select}
              isMulti
              closeMenuOnSelect={false}
              options={availableTabletItems}
              placeholder={t('mnt_access_profiles.tablet')}
            />
          </div>
        </div>
        <div className="form__form-group form__form-group-input-wrap--error-above">
          <span className="form__form-group-label">{t('general.access')}</span>
          <div className="form__form-group-field">
            <Grid
              x12="true"
              container
              direction="column"
              justify="flex-start"
              alignItems="stretch"
              className={classes.Grid}
              component="div"
            >
              <Field
                name="profileFeatures"
                type="text"
                component={CheckBoxGroup}
                parents={features}
                onItemClickHandler={itemClickHandler}
              />
            </Grid>
          </div>
        </div>
        <ButtonToolbar>
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

AccessProfileForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'AccessProfileForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(
  withTranslation('common')(
    connect((state) => ({
      loading: state.loading,
    }))(AccessProfileForm)
  )
);
